// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"style_pageContainer__mYKgK","paragraph":"style_paragraph__3R0R1"};